"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var _hooks = require("@alycecom/hooks");

var PhoneSetting = function PhoneSetting(_ref) {
  var phone = _ref.phone,
      isLoading = _ref.isLoading,
      errors = _ref.errors,
      onSave = _ref.onSave;

  var _useState = (0, _react.useState)(phone),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      phoneValue = _useState2[0],
      setPhoneValue = _useState2[1];

  var savePhone = (0, _react.useCallback)(function () {
    onSave(phoneValue);
  }, [onSave, phoneValue]);
  var handleSavePhone = (0, _react.useCallback)(function () {
    return savePhone();
  }, [savePhone]);
  var onEnterPress = (0, _hooks.useKeyPressEnter)(handleSavePhone);
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "column"
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 5,
    container: true,
    direction: "row"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1,
    mt: 3,
    mr: 1.5
  }, /*#__PURE__*/_react.default.createElement(_ui.BaseField, {
    name: "phone",
    label: "Your phone number",
    placeholder: "Your phone number",
    fullWidth: true,
    value: phoneValue,
    disabled: isLoading,
    errors: errors,
    onChange: (0, _react.useCallback)(function (e) {
      return setPhoneValue(e.target.value);
    }, []),
    onKeyPress: onEnterPress
  }))), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 2
  }, /*#__PURE__*/_react.default.createElement(_ui.ActionButton, {
    onClick: savePhone,
    disabled: isLoading
  }, "Save")));
};

PhoneSetting.propTypes = {
  phone: _propTypes.default.string.isRequired,
  isLoading: _propTypes.default.bool,
  // eslint-disable-next-line react/forbid-prop-types
  errors: _propTypes.default.object,
  onSave: _propTypes.default.func.isRequired
};
PhoneSetting.defaultProps = {
  isLoading: false,
  errors: {}
};
var _default = PhoneSetting;
exports.default = _default;